module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('banner'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('router-view')], 1)]), _vm._v(" "), _c('my-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49c67250","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 61
// module chunks = 0